export const NO_VALUE = Symbol('kzn_filters_no_value');
export const UNRESOLVED = Symbol('kzn_filters_unresolved');

export const FILTER_TYPE_STEP = 'filter_type';